export const AUTO_LINK_STUDIO_FALLBACK_NAME = 'My Studio';

interface BridgeLinkDetails {
  readonly name?: string | null;
}

type FetchLinkRequest<RequestId extends string> = (
  requestId: RequestId,
  token: string
) => Promise<BridgeLinkDetails>;

const normalizeStudioName = (value: string | null | undefined): string | undefined => {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
};

export const resolveAutoLinkStudioName = async <RequestId extends string>({
  requestId,
  token,
  hostname,
  fetchLinkRequest
}: {
  requestId: RequestId;
  token: string;
  hostname: string | undefined;
  fetchLinkRequest: FetchLinkRequest<RequestId>;
}): Promise<string> => {
  try {
    const bridge = await fetchLinkRequest(requestId, token);
    const bridgeName = normalizeStudioName(bridge.name);

    if (bridgeName) {
      return bridgeName;
    }
  } catch (error) {
    console.warn('[auto-link] Failed to resolve bridge name for studio naming:', error);
  }

  return normalizeStudioName(hostname) ?? AUTO_LINK_STUDIO_FALLBACK_NAME;
};
